import { render, staticRenderFns } from "./xinzangwuyou.vue?vue&type=template&id=dcf34b80&scoped=true"
import script from "./xinzangwuyou.vue?vue&type=script&lang=ts"
export * from "./xinzangwuyou.vue?vue&type=script&lang=ts"
import style0 from "./xinzangwuyou.vue?vue&type=style&index=0&id=dcf34b80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf34b80",
  null
  
)

export default component.exports